import React from 'react';
import NumberFormat from 'react-number-format';
import * as PropTypes from 'prop-types';

function NumberFormatDecimal3(props) {
    const { inputRef, onChange, ...other } = props;

    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={values => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.floatValue,
                    },
                });
            }}
            thousandSeparator=" "
            allowNegative={false}
            decimalScale={3}
            decimalSeparator=","
            isNumericString

        />
    );
}

NumberFormatDecimal3.propTypes = {
    inputRef: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
};

export default NumberFormatDecimal3;